import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserDisplayName } from '../api/auth';
import { useAuth } from '../context/AuthContext';

const AdminHomePage: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const displayName = getUserDisplayName(user);

  const handleLogout = () => {
    logout();
    navigate('/', { replace: true });
  };

  return (
    <main className="auth-page">
      <section className="auth-card admin-card admin-menu-card">
        <p className="auth-eyebrow">ADMIN HOME</p>
        <h1>{displayName} 관리자님, 반갑습니다</h1>
        <p className="auth-description">
          관리자 기능을 선택하세요. 회원정보관리에서 가입자 목록과 명단 갱신 기능을 사용할 수 있습니다.
        </p>

        <div className="admin-menu-grid">
          <button
            type="button"
            className="admin-menu-button"
            onClick={() => navigate('/admin/members')}
          >
            <strong>회원정보관리</strong>
            <span>같은 학원명의 가입자 목록을 확인하고 직접 갱신합니다.</span>
          </button>

          <button
            type="button"
            className="admin-menu-button admin-menu-button-secondary"
            onClick={() => navigate('/admin/attendance')}
          >
            <strong>학습일정관리</strong>
            <span>학생별 요일 시간표와 보강 일정을 관리합니다.</span>
          </button>

          <button
            type="button"
            className="admin-menu-button"
            onClick={() => navigate('/admin/attendance-check')}
          >
            <strong>출석체크</strong>
            <span>수업 출석 체크 화면입니다.</span>
          </button>

          <button
            type="button"
            className="admin-menu-button admin-menu-button-secondary"
            onClick={() => navigate('/admin/group-message')}
          >
            <strong>그룹/단체 문자</strong>
            <span>학생을 선택해 단체 문자 대상을 관리합니다.</span>
          </button>
        </div>

        <button type="button" className="auth-secondary-button admin-home-logout" onClick={handleLogout}>
          로그아웃
        </button>
      </section>
    </main>
  );
};

export default AdminHomePage;
